import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { BaseController } from '@shared/src/controllers/base.controller';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Observable, Subject } from 'rxjs';
import { TotemDto } from './TotemDto';
import { TotemPhaseSlotDto } from './TotemPhaseSlotDto';
import { TotemUriQrValuesDto } from './TotemUriQrValuesDto';

@Injectable({
    providedIn: 'root',
})
export class TotemController extends BaseController {


    private base = '/totem'

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router);
    }

    public getSetting(id: number): Observable<TotemDto> {
        return this.get(this.base + "/setting/" + id);
    }
    public next(totemSetting: TotemDto): Observable<TotemDto> {
        return this.post(this.base + "/next", totemSetting, "next");
    }
    public action(totemSetting: TotemDto, actionId: string): Observable<TotemDto> {
        return this.post(this.base + "/action/" + actionId, totemSetting, "action");
    }
    public refresh(totemSetting: TotemDto): Observable<TotemDto> {
        return this.post(this.base + "/refresh", totemSetting, "refresh");
    }

    public back(totemSetting: TotemDto): Observable<TotemDto> {
        return this.post(this.base + "/back", totemSetting, "back");
    }

    public identifyRoute(totemSetting: TotemDto, searchText: string): Observable<TotemDto> {
        return this.post(this.base + "/identify/" + searchText, totemSetting, "identify");
    }

    public idverifyRoute(totem: TotemDto, idVerifyText: string): Observable<TotemDto> {
        return this.post(this.base + "/idverify/" + idVerifyText, totem, "idverify");
    }

    public getPhaseSlot(phaseId: number): Observable<TotemPhaseSlotDto> {
        return this.post(this.base + "/phaseslot", phaseId, "idverify");
    }
    public reload(totemSetting: TotemDto): Observable<TotemDto> {
        return this.post(this.base + "/reload", totemSetting, "reload");
    }
    
        public getUriPageValues(uri: string): Observable<TotemUriQrValuesDto> {
        return this.post(this.base + "/public/uripagevalues/", uri, "uripagevalues");
    }
}
